export const environment = {
  production: true,
  features: {
    enableMenuItemPicture: true,
  },
  routes : {
    reservations: false
  }
};
